module.exports = __webpack_public_path__ + "img/question12c2.2497df5b.png";